import { createFileRoute } from "@tanstack/react-router";
import CssGeneratorPage from "@/pages/CssGeneratorPage";

export const Route = createFileRoute("/tools/css-generator")({
  component: CssGeneratorPage,
});
